<!-- @format -->

<span
	hmf-action-text
	id="pdp-change-zip-code-link"
	variant="secondary"
	(click)="openZipCodePanel()">
	<span class="zip-code-text" [ngClass]="{
		'primary-color': zipcode() === 'null' || !zipcode(),
		'disabled': isDisabled(),
		'subtle': isSubtle(),
		'hmf-body-m hmf-body-md-l': isSubtext(),
		'hmf-body-s hmf-body-md-m': !isSubtext()
	}">
		@if (sameDayDeliveryEnabled()) {
			{{ zipcode() === 'null' || !zipcode() ? 'Enter ZIP' : zipcode() }}
		} @else {
			{{ zipcode() === 'null' || !zipcode() ? 'Enter Delivery Location' : zipcode() }}
		}
	</span>
</span>
